import { useFormState } from 'react-use-form-state';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from '@apollo/react-hooks';
import { useHistory } from 'react-router';

import { AUTHENTICATE_CUSTOMER } from './queries';
import { routes } from '../../constants';

const _v = {
  email: 'email',
  password: 'password',
};

const useAuthenticateCustomer = () => {
  const [formState, form] = useFormState({});
  const { addToast } = useToasts();
  const history = useHistory();

  const [runMutation, { loading }] = useMutation(AUTHENTICATE_CUSTOMER, {
    onCompleted: ({ authenticateCustomerWithPassword: { item, token } }) => {
      if (token != null || token !== 'undefined') {
        localStorage.setItem('api-key', token);
      }

      formState.reset();
      const time = 3000;
      addToast(`Welcome Back, ${item.lastName}`, {
        appearance: 'success',
        autoDismiss: true,
        autoDismissTimeout: time,
      });

      setTimeout(() => history.push(routes.dashboard.pathname), time);
    },
    onError: (err) => {
      console.log(err);
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((e) => {
          if (e.message.includes('E11000 duplicate key error collection: browncon.customers index: email_1 dup key:')) {
            addToast(
              "Seems you are already registered with us. Can't wait to work with you, We'll get back to you shortly",
              {
                appearance: 'success',
                autoDismiss: true,
                autoDismissTimeout: 10000,
              },
            );
          } else {
            addToast(e.message, {
              appearance: 'error',
              autoDismiss: true,
            });
          }
        });
      } else {
        addToast('Something unexpected happened, Try Again later', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // TODO: validation

    runMutation({ variables: formState.values });
  };

  return {
    _v,
    form,
    formState,
    handleSubmit,
    loading,
  };
};

export default useAuthenticateCustomer;
